import { render, staticRenderFns } from "./GiftsGenerator.vue?vue&type=template&id=c5376772&"
import script from "./GiftsGenerator.vue?vue&type=script&lang=js&"
export * from "./GiftsGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports